import React, { useEffect, useState } from "react";
import { db } from "../../config/firebase";
import { doc, getDoc, updateDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import { useMyContext } from "../../context/MyContext";
import { Tooltip } from "antd";
import HistoryIcon from "./History";

const UpdateInquireNumber = () => {
  const { user } = useMyContext();
  const [formData, setFormData] = useState({
    inquireNumber_Prefix: "",
  });
  const [initialValue, setInitialValue] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const settingsDocRef = doc(db, "settings", "settings");
        const settingsDocSnap = await getDoc(settingsDocRef);

        if (settingsDocSnap.exists()) {
          const data = settingsDocSnap.data();
          setFormData(data);
          setInitialValue(data.inquireNumber_Prefix || "");
        } else {
          toast.error("Settings data not found");
        }
      } catch (error) {
        console.error("Error fetching settings data:", error);
        toast.error("Error fetching settings data. Please try again later.");
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddData = async () => {
    try {
      // Only proceed if the value has changed
      if (initialValue !== formData.inquireNumber_Prefix) {
        const settingsDocRef = doc(db, "settings", "settings");
        await updateDoc(settingsDocRef, formData);

        // Add to history collection
        const historyCollectionRef = collection(db, "prefixHistory");
        await addDoc(historyCollectionRef, {
          prefixType: "Inquire Number Prefix",
          oldValue: initialValue,
          newValue: formData.inquireNumber_Prefix,
          updatedBy: user?.name || user?.email || "Unknown user",
          updatedById: user?.uid,
          timestamp: serverTimestamp()
        });

        // Update the initial value to the new value
        setInitialValue(formData.inquireNumber_Prefix);

        toast.success("Inquire Number updated successfully!");
      } else {
        toast.info("No changes detected");
      }
    } catch (error) {
      console.error("Error updating inquire number prefix:", error);
      toast.error("Error updating inquire number prefix. Please try again later.");
    }
  };

  return (
    <div>
      <div className="w-full">
        <div className="flex flex-col gap-1 py-2">
          <div className="flex items-center justify-between">
            <label
              className="w-full text-sm font-normal"
              htmlFor="inquireNumberPrefix"
            >
              Inquire Number Prefix Update
            </label>
            <HistoryIcon prefixType="Inquire Number Prefix" />
          </div>
          <input
            type="text"
            placeholder="Inquire Number Prefix"
            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
            id="inquireNumber_Prefix"
            onChange={handleInputChange}
            value={formData.inquireNumber_Prefix}
            name="inquireNumber_Prefix"
            disabled={user?.role === "super admin" ? false : true}
          />
        </div>
        <Tooltip
          title={
            user?.role === "super admin"
              ? ""
              : "You cannot edit it in your current role"
          }
        >
          <button
            onClick={handleAddData}
            className={`px-8 py-2 rounded-lg text-sm text-[#fff] ${user?.role === "super admin"
                ? "bg-[#03336E]"
                : "cursor-not-allowed bg-gray-300"
              }`}
            disabled={user?.role === "super admin" ? false : true}
          >
            Update Inquire No
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default UpdateInquireNumber;